module.exports = __webpack_public_path__ + "assets/img/didifunLogo.47f736d2.svg";